import { Loader } from "@googlemaps/js-api-loader"
import additional from "../additional"
import { getSeyirMarkerInstance } from "./additional/seyir-marker"

//sertellojistikapi@gmail.com
//123456Fg.hj
//AIzaSyBFH2VsMHb5k-1FJx_01ZRLW517jymRlME

export default class{
    apiKey = "AIzaSyBFH2VsMHb5k-1FJx_01ZRLW517jymRlME"
    google = null

    constructor(){ 
        this.Connect() 
    }

    Connect(){
        this.google = new Loader({apiKey: this.apiKey, libraries: ["places"]})
        
    }

    GetDistance(origins,destinations,avoidHighways,avoidTolls,index){
        return new Promise((resolve,reject)=>{
            this.google.load().then((google)=>{
                const service = new google.maps.DistanceMatrixService()
                additional.Wait(100*index).then(()=>{
                    service.getDistanceMatrix({
                        origins: [origins], 
                        destinations: [destinations],
                        travelMode: 'DRIVING',
                        unitSystem: google.maps.UnitSystem.METRIC,
                        avoidHighways: avoidHighways,
                        avoidTolls: avoidTolls
                    },(response,status)=>{
                        if(status === 'OK') resolve(response)
                        else reject(response)
                    })
                }).catch((e)=>reject(e))
            })
        })
    }

    RenderMapWithRoute(element,origin,destination,waypoints = [],avoidHighways,avoidTolls){
        this.google.load().then((google)=>{
            const map = new google.maps.Map(element,{ 
                center: {lat: 38.925533,lng: 32.866287,},
                zoom: 6, 
                streetViewControl: false,
                fullscreenControl: false,
            })
            const directionService = new google.maps.DirectionsService()
            const directionDisplay = new google.maps.DirectionsRenderer({
                map: map,
                draggable: false,
            })

            directionService.route({
                origin: origin,
                destination: destination,
                waypoints: waypoints.map(wp=>{ return{ location:wp } }),
                travelMode: 'DRIVING',
                avoidHighways: avoidHighways,
                avoidTolls: avoidTolls
            },(res)=>{
                if(res.status === 'OK'){
                    directionDisplay.setDirections(res)
                }
            },(err)=>{
                console.log(err)
            })
        })
    }

    RenderMapForFindLocation(element,callback,pos,settable = true){
        return new Promise((resolve,reject)=>{
            let markers = []
            this.google.load().then((google)=>{

                const geocoder = new google.maps.Geocoder()

                const map = new google.maps.Map(element,{ 
                    center: {lat: 38.925533,lng: 32.866287,},
                    zoom: 6, 
                    streetViewControl: false,
                    fullscreenControl: false,
                })

                map.addListener('contextmenu',()=>{ 
                    markers.forEach(m=>m.setMap(null)) 
                    if(callback) callback(null)
                })

                if(pos != null && pos.lat && pos.lng){
                    markers.forEach(marker => marker.setMap(null))
                    const marker = new google.maps.Marker({
                        position: {lat:pos.lat,lng:pos.lng},
                        map,
                        title: "Selected Position",
                    })
                    markers.push(marker)
                }

                if(settable){
                    map.addListener("click", (mapsMouseEvent) => {
                        markers.forEach(marker => marker.setMap(null))
                        const marker = new google.maps.Marker({
                            position:  mapsMouseEvent.latLng,
                            map,
                            title: "Selected Position",
                        })
                        
                        if(callback) callback({
                            lat: mapsMouseEvent.latLng.lat(),
                            lng: mapsMouseEvent.latLng.lng()
                        })
                        markers.push(marker)
                    });
                }

                const setCenter = (address) =>{
                    geocoder.geocode({'address': address}, (results, status) => {
                        if(status === 'OK'){
                            let lat = results[0].geometry.location.lat()
                            let lng = results[0].geometry.location.lng()
                            let LL = new google.maps.LatLng(lat,lng)
                            map.panTo(LL)
                            var resultBounds = new google.maps.LatLngBounds(
                                results[0].geometry.viewport.getSouthWest(), 
                                results[0].geometry.viewport.getNorthEast()
                            );
                            map.fitBounds(resultBounds);
                        }
                    })
                }

                const setCenterLatLng = (lat,lng) => {
                    let LL = new google.maps.LatLng(lat,lng)
                    map.panTo(LL,9)
                }

                const reset = () => {
                    markers.forEach(m=>m.setMap(null)) 
                    if(callback) callback(null)
                    
                    let LL = new google.maps.LatLng(38.925533,32.866287)
                    map.panTo(LL)
                    map.setZoom(6)
                }

                resolve({
                    map,
                    setCenter,
                    setCenterLatLng,
                    reset
                })
            })
        })
    }


    RenderMapWithMarkers(element){
        return new Promise((resolve)=>{
            let markers = []
            this.google.load().then((google)=>{

                
                const map = new google.maps.Map(element,{ 
                    center: {lat: 38.925533,lng: 32.866287,},
                    zoom: 4, 
                    streetViewControl: false,
                    fullscreenControl: false,
                })

                const SeyirMarker = getSeyirMarkerInstance(google,map)

                const reset = () =>{
                    markers.forEach(m=>m.setMap(null)) 
                }

                const setMarkers = (mrkrs,callback)=>{
                    markers.forEach(m =>m.setMap(null))
                    markers = []
                    mrkrs.forEach(m=>{
                        const marker = new SeyirMarker(new google.maps.LatLng(m.Latitude,m.Longitude),m,callback)
                        markers.push(marker)
                        marker.setMap(map)
                    })
                } 

                resolve({
                    map,
                    setMarkers,
                    reset
                })
            })
        })
    }


    // SearchPlace(input){
    //     this.google.load().then((google)=>{
    //         const center = {lat: 38.41872,lng: 27.129601,};
    //         // Create a bounding box with sides ~10km away from the center point
    //         const defaultBounds = {
    //             north: center.lat + 1,
    //             south: center.lat - 1,
    //             east: center.lng + 1,
    //             west: center.lng - 1,
    //         };
    //         const options = {
    //             bounds: defaultBounds,
    //             componentRestrictions: { country: "tr" },
    //             fields: ["address_components", "geometry", "icon", "name"],
    //             strictBounds: false,
    //             types: ["locality","street_address"],
    //         };
    //         const autocomplete = new google.maps.places.Autocomplete(input, options);
    //     })
    // }

    // ParseGeocodeResult(results,status){
    //     if (status == google.maps.GeocoderStatus.OK) {
    //         if (results[1]) {
    //             var country = null, countryCode = null, city = null, cityAlt = null;
    //             var c, lc, component;
    //             for (var r = 0, rl = results.length; r < rl; r += 1) {
    //                 var result = results[r];
    
    //                 if (!city && result.types[0] === 'locality') {
    //                     for (c = 0, lc = result.address_components.length; c < lc; c += 1) {
    //                         component = result.address_components[c];
    
    //                         if (component.types[0] === 'locality') {
    //                             city = component.long_name;
    //                             break;
    //                         }
    //                     }
    //                 }
    //                 else if (!city && !cityAlt && result.types[0] === 'administrative_area_level_1') {
    //                     for (c = 0, lc = result.address_components.length; c < lc; c += 1) {
    //                         component = result.address_components[c];
    
    //                         if (component.types[0] === 'administrative_area_level_1') {
    //                             cityAlt = component.long_name;
    //                             break;
    //                         }
    //                     }
    //                 } else if (!country && result.types[0] === 'country') {
    //                     country = result.address_components[0].long_name;
    //                     countryCode = result.address_components[0].short_name;
    //                 }
    
    //                 if (city && country) {
    //                     break;
    //                 }
    //             }
    
    //             return {
    //                 City: city,
    //                 CityAlt: cityAlt,
    //                 Country: country,
    //                 CountryCode: countryCode
    //             }
    //         }
    //     }
    // }
} 